import React from 'react';
import Const from './Const';
import {
  GeneralContentSetting,
  NotificationContentSetting,
  ContactContentSetting,
} from './chidren-content/index';
import enhanceWithClickOutside from 'react-click-outside';
import HeaderPopup from './header-popup/HeaderPopup';
import { Translate } from 'react-redux-i18n';

class SystemSettingPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listTab: [
        {
          value: 'general',
          isSelected: true,
          index: Const.listTab.General.Index,
        },
        {
          value: 'notifications',
          isSelected: false,
          index: Const.listTab.Notification.Index,
        },
        {
          value: 'contact',
          isSelected: false,
          index: Const.listTab.Contact.Index,
        },
      ],
      indexSelectTab: 1,
    };
  }

  handleClickOutside = () => {
    const { isShow, toggleSaveSystemSetting } = this.props;
    if (isShow) {
      toggleSaveSystemSetting();
    }
  };

  changeTab(value) {
    const { listTab } = this.state;
    const newListTab = listTab.map(item => {
      if (value === item.index)
        return {
          ...item,
          isSelected: true,
        };
      return {
        ...item,
        isSelected: false,
      };
    });
    this.setState({ listTab: newListTab, indexSelectTab: value });
  }

  render() {
    const { listTab, indexSelectTab } = this.state;

    return (
      <div className="wrap-popup-setting">
        <HeaderPopup handleClickOutside={this.handleClickOutside} />

        <div className="body-popup">
          <div className="left-title">
            {listTab.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`${
                    item.isSelected ? 'title-tab-content-active' : ''
                  } title-tab-content hover"`}
                  onClick={() => this.changeTab(item.index)}
                >
                  <Translate value={`systemSetting.listTab.${item.value}`} />
                </div>
              );
            })}
          </div>
          <div className="right-info-setting">
            {indexSelectTab === 1 && <GeneralContentSetting />}
            {indexSelectTab === 2 && <NotificationContentSetting />}
            {indexSelectTab === 3 && <ContactContentSetting />}
          </div>
        </div>
      </div>
    );
  }
}

export default enhanceWithClickOutside(SystemSettingPopup);
